module.exports = __webpack_public_path__ + "img/podcast.cb5f214.webp";